import React from 'react';
import { Modal, Button } from 'antd-mobile';
import { useLocation, useNavigate } from 'react-router-dom';
import { t } from '../i18n';
import { DriverAuthPath } from '../enums/DriverAuthPathEnum';
import { DELIVERY_NATIVE_PATH_PREFIX, DeliveryNativePath } from '../enums/DeliveryNavigatePathEnum';

interface NoAccountModalProps {
    visible: boolean;
    onClose: () => void;
}

export const NoAccountModal: React.FC<NoAccountModalProps> = ({ visible, onClose }) => {
    const navigate = useNavigate();
    const location = useLocation();
    // native 入口(NativeApp)只注册 /delivery-native/* 路由，跳 main 入口的 /driver/register 会白屏
    const registerPath = location.pathname.startsWith(DELIVERY_NATIVE_PATH_PREFIX)
        ? DeliveryNativePath.DRIVER_REGISTER
        : DriverAuthPath.DRIVER_REGISTER;

    return (
        <Modal
            visible={visible}
            content={
                <div>
                    <div className="py-4 text-center">
                        {t('pages.login.noAccountMessage')}
                    </div>
                    <div className="flex gap-3 px-4 pb-2">
                        <Button
                            block
                            fill="outline"
                            onClick={onClose}
                            className="text-sm"
                        >
                            {t('pages.login.cancel')}
                        </Button>
                        <Button
                            block
                            color="primary"
                            onClick={() => {
                                onClose();
                                navigate(registerPath);
                            }}
                            className="text-sm"
                        >
                            {t('pages.login.goToRegister')}
                        </Button>
                    </div>
                </div>
            }
            closeOnAction
            onClose={onClose}
        />
    );
};

